var map = {
	"./download/download.module": [
		"./src/app/download/download.module.ts",
		"download-download-module"
	],
	"./map/map.module": [
		"./src/app/map/map.module.ts",
		"map-map-module"
	],
	"./mybaby/editbabymodal/editbabymodal.module": [
		"./src/app/mybaby/editbabymodal/editbabymodal.module.ts",
		"mybaby-editbabymodal-editbabymodal-module"
	],
	"./mybaby/newbabymodal/newbabymodal.module": [
		"./src/app/mybaby/newbabymodal/newbabymodal.module.ts",
		"mybaby-newbabymodal-newbabymodal-module"
	],
	"./personalise-images/personalise-images.module": [
		"./src/app/personalise-images/personalise-images.module.ts",
		"personalise-images-personalise-images-module"
	],
	"./progress-doughnut-chart/progress-doughnut-chart.module": [
		"./src/app/progress-doughnut-chart/progress-doughnut-chart.module.ts",
		"progress-doughnut-chart-progress-doughnut-chart-module"
	],
	"./progress-pie-chart/progress-pie-chart.module": [
		"./src/app/progress-pie-chart/progress-pie-chart.module.ts",
		"progress-pie-chart-progress-pie-chart-module"
	],
	"./tutorial/tutorial.module": [
		"./src/app/tutorial/tutorial.module.ts",
		"tutorial-tutorial-module"
	],
	"./viewwordlist/viewwordlist.module": [
		"./src/app/viewwordlist/viewwordlist.module.ts",
		"viewwordlist-viewwordlist-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;